import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneMask',
})
export class PhoneMask implements PipeTransform {
  transform(value: any): string {
    if (!value) {
      return '';
    }

    const cleaned = value.toString().replace(/\D/g, '');

    if (cleaned.length == 0) {
      return value;
    }

    const mask = cleaned.length === 10 ? '(###) ###-####' : '+# (###) ###-####';

    let result = '';
    let index = 0;
    for (let i = 0; i < mask.length; i++) {
      if (mask[i] === '#') {
        if (index < cleaned.length) {
          result += cleaned[index];
          index++;
        } else {
          break;
        }
      } else {
        result += mask[i];
      }
    }

    return result;
  }
}
